<!-- ======= Header ======= -->
<header id="header" class="header fixed-top d-flex align-items-center">
  <div class="d-flex align-items-center justify-content-between">
    <a href="index.html" class="logo d-flex align-items-center">
      <img src="https://patient-tracker.s3.us-east-1.amazonaws.com/image/logo.png" alt="" />
      <span class="d-none d-lg-block">Patient Tracker</span>
    </a>
    <a href="javascript:void(0)" class="toggle-sidebar-btn" (click)="ToggleSidebar()">
      <i class="bi bi-list"></i>
    </a>
  </div>
  <!-- End Logo -->

  <div class="search-bar">
    <div class="form-group">
      <div class="input-group">
        <select *ngIf="!IsLoading" class="form-select form-control" id="clinicId" [disabled]="UserDetails.clinicId" aria-label="Clinic" (change)="ChangeClinic()" [(ngModel)]="SelectedClinic">
          <option [value]="0" *ngIf="!UserDetails.clinicId">All Clinic</option>
          <ng-container *ngFor="let clinic of ListClinics">
            <option [value]="clinic.id">{{ clinic.clinicName }}</option>
          </ng-container>
        </select>

        <div class="placeholder" *ngIf="IsLoading"></div>
      </div>
    </div>
  </div>
  <!-- End Search Bar -->

  <nav class="header-nav ms-auto">
    <ul class="d-flex align-items-center">
      <li class="nav-item dropdown pe-3">
        <a class="nav-link nav-profile d-flex align-items-center pe-0" href="#" data-bs-toggle="dropdown">
          <img src="https://patient-tracker.s3.us-east-1.amazonaws.com/image/profile-img.jpg" alt="Profile" class="rounded-circle" />
          <span class="d-none d-md-block dropdown-toggle ps-2">{{ UserDetails.firstName }} {{ UserDetails.lastName }}</span> </a
        ><!-- End Profile Iamge Icon -->

        <ul class="dropdown-menu dropdown-menu-end dropdown-menu-arrow profile pt-0">
          <li>
            <button routerLink="./profile" class="btn dropdown-item d-flex align-items-center justify-content-start">
              <i class="bi bi-person"></i>
              <span>My Profile</span>
            </button>
          </li>
          <li>
            <hr class="dropdown-divider" />
          </li>
          <li>
            <button class="btn dropdown-item d-flex align-items-center justify-content-start" (click)="SignOut()">
              <i class="bi bi-box-arrow-right"></i>
              <span>Sign Out</span>
            </button>
          </li>
        </ul>
        <!-- End Profile Dropdown Items -->
      </li>
      <!-- End Profile Nav -->
    </ul>
  </nav>
  <!-- End Icons Navigation -->
</header>
<!-- End Header -->
